// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1XCCu","title":"FrontImage_title__C2ttN"};